function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n            .cls-1{fill:#050c1a}.cls-2{fill:none}\n        "));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "ic-keyboard-arrow-down-48px",
  transform: "translate(0 .75)"
}, React.createElement("path", {
  id: "Path_18",
  d: "M14.83 16.42L24 25.59l9.17-9.17L36 19.25l-12 12-12-12z",
  className: "cls-1",
  "data-name": "Path 18"
}), React.createElement("path", {
  id: "Path_19",
  d: "M0-.75h48v48H0z",
  className: "cls-2",
  "data-name": "Path 19"
}));

var SvgIcKeyboardArrowDown48Px = function SvgIcKeyboardArrowDown48Px(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcKeyboardArrowDown48Px, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-keyboard-arrow-down-48px.815c4f8d.svg";
export { ForwardRef as ReactComponent };